module.exports = __webpack_public_path__ + "static/media/volume-2.087d11a1.svg";